const FALLBACK_TEMPLATE = "iSmile - %{title}"
const FALLBACK_NAME = "iSmile"

function datasetValue(key) {
  if (typeof document === "undefined") return ""
  const el = document.querySelector("title[data-inertia]")
  return el?.dataset?.[key] || ""
}

// Prefix every Inertia <Head title> with the brand. Templates come from
// the layout (`ui.document_title`) so locales stay the source of truth.
export function documentTitle(title, { template, appName } = {}) {
  const resolvedTemplate = template || datasetValue("titleTemplate") || FALLBACK_TEMPLATE
  const resolvedName = appName || datasetValue("titleDefault") || FALLBACK_NAME
  const trimmed = String(title ?? "").trim()

  if (!trimmed || trimmed === resolvedName) return resolvedName
  if (trimmed.startsWith(`${resolvedName} - `)) return trimmed

  return resolvedTemplate.replace("%{title}", trimmed)
}
